document.addEventListener('DOMContentLoaded' , () =>{
    // product - js-btn-col
    if(document.querySelector('.js-btn-col')){
        let btnCol = document.querySelectorAll('.js-btn-col'),
            prdList = document.querySelectorAll('.prd-list');
        
        btnCol.forEach(function(el){
            let colToggleBtnArray = Array.from(el.parentNode.querySelectorAll('.js-btn-col'));

            el.addEventListener('click' , function(e){
                if(!el.classList.contains('on')){
                    colToggleBtnArray.forEach(function(el){
                        el.classList.remove('on');
                    });
                    el.classList.add('on');
                }

                //목록 스타일
                if(el.classList.contains('btn-col1')){
                    prdList.forEach(function(el){
                        el.className = 'prd-list prd-list--col1';
                    })
                }else{
                    prdList.forEach(function(el){
                        el.className = 'prd-list';
                    })
                }
            });
        })
    }

    // main - main-page
    if(document.querySelector('.main-page')){
        const mainVisual = new Swiper(".main-visual", {
            pagination: {
                el: ".main-visual .swiper-pagination",
            },
            loop: true,
            autoplay: {
                delay: 3000,
            },
            centeredSlides: true,
            slidesPerView: 1.15,
            spaceBetween: 8,
            observer : true,
            observeParents : true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 8,
                },
            },
        });

        let prdPcSwiper = [];
        function prdPcSwiperFn() {
            const elements = document.querySelectorAll('.pc-slide-area .comm-product');

            if (window.innerWidth >= 767){
                //PC
                if (prdPcSwiper.length === 0){
                    elements.forEach((el) => {
                        prdPcSwiper.push(new Swiper(el, {
                            spaceBetween: 16,
                            slidesPerView: 4,
                            centeredSlides: true,
                            loop: true,
                            navigation: {
                                nextEl: el.querySelector(".common-swiper-next"),
                                prevEl: el.querySelector(".common-swiper-prev"),
                            },
                        }));
                    });
                }
            }else{
                //MB
                prdPcSwiper.forEach(sw => sw.destroy());
                prdPcSwiper = [];
            }
        }
        prdPcSwiperFn();
        window.addEventListener("resize", prdPcSwiperFn);

        const dealList = new Swiper(".main-content--deal .comm-product", {
            navigation: {
                nextEl: ".deal-slide-area .common-swiper-next",
                prevEl: ".deal-slide-area .common-swiper-prev",
            },
            slidesPerView: 'auto',
            spaceBetween: 13,
            breakpoints: {
                768: {
                    loop: true,
                    centeredSlides: true,
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
            },
        });

        let keywordTagMbSwiper = [];
        function keywordTagMbSwiperFn() {
            if (window.innerWidth >= 767){
                //PC
                keywordTagMbSwiper.forEach(sw => sw.destroy());
                keywordTagMbSwiper = [];
            }else{
                //MB
                if (keywordTagMbSwiper.length === 0){
                    keywordTagMbSwiper.push(new Swiper('.main-content--keyword .common-tag', {
                        spaceBetween: 4,
                        slidesPerView: 'auto',
                    }));
                }
            }
        }
        keywordTagMbSwiperFn();
        window.addEventListener("resize", keywordTagMbSwiperFn);

        let keywordPcSwiper = [];
        function keywordPcSwiperFn() {
            if (window.innerWidth >= 767){
                //PC
                if (keywordPcSwiper.length === 0){
                    keywordPcSwiper.push(new Swiper('.main-content--keyword .comm-product', {
                        spaceBetween: 16,
                        slidesPerView: 3,
                        loop: true,
                        navigation: {
                            nextEl: document.querySelector(".main-content--keyword .comm-product .common-swiper-next"),
                            prevEl: document.querySelector(".main-content--keyword .comm-product .common-swiper-prev"),
                        },
                    }));
                }
            }else{
                //MB
                keywordPcSwiper.forEach(sw => sw.destroy());
                keywordPcSwiper = [];
            }
        }
        keywordPcSwiperFn();
        window.addEventListener("resize", keywordPcSwiperFn);

        const bannerList = new Swiper(".main-content--banner .banner-list", {
            pagination: {
                el: ".banner-list .swiper-pagination",
            },
            loop: true,
            autoplay: {
                delay: 3000,
            },
            slidesPerView: 'auto',
        });

        const reviewArea = new Swiper(".review-area .review-area__box", {
            loop: false,
            centeredSlides: false,
            slidesPerView: 'auto',
            spaceBetween: 13,
            breakpoints: {
                768: {
                    loop: true,
                    centeredSlides: true,
                    slidesPerView: 4,
                    spaceBetween: 16,
                },
            },
        });
    }
});